import React, { lazy, Suspense } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Spin, Col, Card, Dropdown, Menu } from 'antd';
import {
  EditOutlined,
  EllipsisOutlined,
  PushpinOutlined,
} from '@ant-design/icons';
import { useSelector } from 'react-redux';
import firebase from 'firebase';

const LazyImage = lazy(() => import('./LazyImage'));

function LazyCard(props) {
  const user = useSelector((state) => state.user);

  const pinHandler = () => {
    if (!user.isLogin) {
      alert('로그인 후 이용 가능합니다.');
      props.history.push('/login');
    } else {
      firebase
        .database()
        .ref('zzals/' + localStorage.getItem('u_id'))
        .push()
        .set(props.image)
        .then((doc) => {
          alert('내 짤주머니에 저장!');
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const editHandler = () => {
    props.history.push({
      pathname: `/edit/${props.image.id}`,
      state: {
        link: props.image.link,
      },
    });
  };

  const shareHandler = () => {
    const { Kakao } = window;
    Kakao.Link.sendDefault({
      objectType: 'feed',
      content: {
        title: '짤을 받으시오',
        description: '#짤방 #짤해 #커스텀짤 #짤생성',
        imageUrl: props.image.link,
        link: {
          webUrl: 'https://zzal-debug.web.app/',
          mobileWebUrl: 'https://zzal-debug.web.app/',
        },
      },
      buttons: [
        {
          title: '더 많은 짤을 찾아..',
          link: {
            webUrl: 'https://zzal-debug.web.app/',
            mobileWebUrl: 'https://zzal-debug.web.app/',
          },
        },
      ],
    });
  };

  const menu = (
    <Menu>
      <Menu.Item key='1' onClick={shareHandler}>
        카카오톡 공유
      </Menu.Item>
    </Menu>
  );

  return (
    <Suspense
      fallback={
        <Col lg={6} md={8} xs={24}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '297px',
              border: '1px solid #eee',
            }}
          >
            <Spin tip='Loading...' />
          </div>
        </Col>
      }
    >
      <Col lg={6} md={8} xs={24}>
        <Card
          hoverable
          bodyStyle={{ display: 'none' }}
          cover={
            <Link
              to={{
                pathname: `/zzal/${props.image.id}`,
                state: {
                  link: props.image.link,
                },
              }}
            >
              <LazyImage link={props.image.link} />
            </Link>
          }
          actions={[
            <EditOutlined key='edit' onClick={editHandler} />,
            <PushpinOutlined key='love' onClick={pinHandler} />,
            <Dropdown overlay={menu}>
              <EllipsisOutlined key='ellipsis' />
            </Dropdown>,
          ]}
        />
      </Col>
    </Suspense>
  );
}

export default withRouter(LazyCard);
